var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscalabilidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166687,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6 30.3167L32.1667 28.75L35.6 27.1834L37.1667 23.75L38.7333 27.1834L42.1667 28.75L38.7333 30.3167L37.1667 33.75L35.6 30.3167ZM18.8333 37.0834L20.4 33.65L23.8333 32.0834L20.4 30.5167L18.8333 27.0834L17.2667 30.5167L13.8333 32.0834L17.2667 33.65L18.8333 37.0834ZM26.3333 28.75L28.15 24.7334L32.1667 22.9167L28.15 21.1L26.3333 17.0834L24.5167 21.1L20.5 22.9167L24.5167 24.7334L26.3333 28.75ZM19.6667 47.9167L29.6667 37.9L36.3333 44.5667L50.5 28.6334L48.15 26.2834L36.3333 39.5667L29.6667 32.9L17.1667 45.4167L19.6667 47.9167Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalabilidad);
export default __webpack_public_path__ + "static/media/escalabilidad.da31489c5184c586ea16c1a629a35b40.svg";
export { ForwardRef as ReactComponent };